export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const LOAD_ACCOUNTS_LIST = 'LOAD_ACCOUNTS_LIST';
export const LOAD_ACCOUNTS_NAMES = 'LOAD_ACCOUNTS_NAMES';
export const UPDATE_ACCOUNT_DESCRIPTION = 'UPDATE_ACCOUNT_DESCRIPTION';
